module.exports = __webpack_public_path__ + "img/outbound--icon.5edee04d.svg";